var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var TargetForSelect = require('./targetForSelect.jsx');

var TargetForSelectList = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){

        var targetForSelectNodes = this.props.targetsForSelect.map(function(target){
            var isChecked = false;
            var isDisabled = false;

            var len = this.props.selectedTargetIDs.length;

            for(var i = 0; i < len; i++){
                if(target._id === this.props.selectedTargetIDs[i]){
                    isChecked = true;
                    break;
                }
            }

            // must have one target at least
            if(this.props.targetsForSelect.length === 1){
                isDisabled = true;
            }

            return <TargetForSelect key={target._id} target={target} isChecked={isChecked} isDisabled={isDisabled} onTargetChange={this.props.onTargetChange} />;
        }.bind(this));

        return (
            <ul className="target-for-select-list clearfix no-bullet">
                {targetForSelectNodes.length ? targetForSelectNodes : (
                    <li>
                        <input id="target_everyone" type="radio" checked disabled />
                        <label htmlFor="target_everyone">Everyone</label>
                    </li>
                )}
            </ul>
        );
    }
});

module.exports = TargetForSelectList;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/targetForSelectList.jsx